import TextField, {TextFieldProps} from "./TextField";
import React from "react";
import {DataTypeTranslationKey} from "../../../pages/main/content/datatype/DataTypeTranslationKey";
import {t} from "../../../store/localization/TranslMessasge";


type NumericFieldProps = Omit<TextFieldProps, 'type' | 'value' | 'onChange' > & {
    value: number | undefined;
    onChange: (value: number | undefined) => void;
    precision: number;
    allowedInputRegex?: RegExp;
};

export function NumericField({
                                 label,
                                 value,
                                 onChange,
                                 errorMessage,
                                 fullWidth,
                                 precision,
                                 clearable,
                                 InputProps,
                                 allowedInputRegex,

                             }: Readonly<NumericFieldProps>) {

    const [validationError, setValidationError] = React.useState<string>();

    const computedStep = parseFloat((1 / Math.pow(10, precision)).toFixed(precision));


    function handleChange(input: string) {

        if (input !== '' && allowedInputRegex && !allowedInputRegex.test(input)) {
            setValidationError(t(DataTypeTranslationKey.INVALID_INPUT_FORMAT) );
            onChange(undefined);
            return;
        }
        setValidationError(undefined);

        if (input === '') {
            onChange(undefined);
            return;
        }

        const numValue = parseFloat(input);
        if (!isNaN(numValue)) {
            const rounded = parseFloat(numValue.toFixed(precision));
            onChange(rounded);
        }
    }

    return (
        <TextField
            label={label}
            type="number"
            inputProps={{step: computedStep, inputMode: computedStep === 1 ? "numeric" : "decimal"}}
            value={value}
            onChange={(value) => handleChange(value)}
            errorMessage={validationError ?? errorMessage}
            fullWidth={fullWidth ?? true}
            clearable={clearable}
            InputProps={InputProps}
        />
    );
}
